import moment from 'moment';
if($('#network-messages').length){
    var app = new Vue({
        el: '#network-messages',
        data: {
            messages: [],
            slug: slug,
            userLevel: userLevel,
            token: token,
            admins:['owner','administrator'],
            message_text: '',
            submitting: false,
            loading: true,
            currentUserImage: currentUserImage,
            canMessage: canMessage,
            params: null,
            scrollTo: scrollTo
        },
        methods: {
            get: function(message) {
                this.loading = true;
                var user = true;
                if(this.userLevel == 'unregistered'){
                    user = false;
                }
                axios.get('/api/v1/network-updates/'+this.slug+'?user='+user).then((response) =>  {
                    this.loading = false;
                    this.messages = response.data.data
                    if(!message){
                        this.scrollDown(this.scrollTo);
                    }
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error)
                    this.$toasted.error('There was an error retrieving messages');
                });
            },
            post: function(message) {
                let parent_id = null;
                let message_text = this.message_text;

                if(message){
                    parent_id = message.id;
                    message_text = message.sub_text;
                    this.loading = true;
                }else{
                    this.submitting = true
                }

                axios.post('/api/v1/network-updates/'+this.slug, {
                    'parent_id':parent_id,
                    'message_text':message_text
                }).then((response) =>  {
                    this.message_text = '';
                    if(message){
                        message.sub_text = '';
                    }
                    this.submitting = false;
                    this.get(message);
                    this.$toasted.success('Your message was posted succesfully');
                }).catch(function (error) {
                    console.log(error);
                    this.submitting = false
                    this.$toasted.error('There was an error posting your message');
                });
            },
            scrollDown: function (id) {
                this.$nextTick(() => {
                    if(!id){
                        var container = this.$el.querySelector(".messages-wrapper");
                        container.scrollTop = container.scrollHeight;
                    }else{
                        var element = document.getElementById('message-'+id);
                        document.getElementById('messages-wrapper-id').scrollTop = element.offsetTop;
                        this.scrollTo = null;
                    }
                });
            },
            getHtml: function(inputText) {
                var replacedText, replacePattern1, replacePattern2, replacePattern3;

                //URLs starting with http://, https://, or ftp://
                replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

                //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
                replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

                //Change email addresses to mailto:: links.
                replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            },
            getTime: function(time){
                var dateFormat = 'HH:mm:a';
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('LLL');
            },
            toggleReply: function(message){
                if(!message.show_reply){
                    var element = document.getElementById('feed-box').scrollIntoView();

                    var element = document.getElementById('message-'+message.id);
                    var bottomPos  = (element.offsetTop + element.offsetHeight) - 120;
                    document.getElementById('messages-wrapper-id').scrollTop = bottomPos;
                    return true;
                }else{
                    return false;
                }
            }
        },
        mounted () {
            this.get();
        }
    });
}